export const DashboardRoutesList = {
  PAYMENT_ROUTE: 'payment',
  PAYOUT_ROUTE: 'payout',
  PAYOUT_BREAKDOWN_ROUTE: 'breakdown',
  VIRTUAL_TERMINAL_ROUTE: 'virtual-terminal',
  SETTINGS_ROUTE: 'settings',
};

export default DashboardRoutesList;
